module.exports = __webpack_public_path__ + "static/media/CallCenterScreen.a1112076.png";